import { useLazyContext } from "@redotech/react-util/context";
import { ConversationTagInput } from "@redotech/redo-merchant-support-app/conversation-tags/conversation-tag-input";
import { ConversationTagsContext } from "@redotech/redo-merchant-support-app/services/conversation-tags-service";
import type { RemoveTagAction as RemoveTagActionType } from "@redotech/redo-model/advanced-flow/rules/schemas";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useMemo } from "react";

export const RemoveTagAction = memo(function RemoveTagAction({
  action,
  onChange,
  editableFields,
}: {
  action: RemoveTagActionType;
  onChange: (updated: RemoveTagActionType) => void;
  editableFields?: ReadonlySet<string>;
}) {
  const tagEditable = editableFields === undefined || editableFields.has("tag");

  const [conversationTags] = useLazyContext(ConversationTagsContext);

  const tagNames = useMemo(() => {
    if (Array.isArray(action.tag)) {
      return new Set(action.tag);
    }
    return new Set(action.tag ? [action.tag] : []);
  }, [action.tag]);

  const tags = useMemo(
    () => conversationTags.value?.filter((tag) => tagNames.has(tag.name)) || [],
    [conversationTags.value, tagNames],
  );

  return (
    <Flex dir="column" gap="sm" w="full">
      <Flex
        style={
          tagEditable ? undefined : { pointerEvents: "none", opacity: 0.6 }
        }
      >
        <ConversationTagInput
          currentTags={tags}
          setCurrentTags={(tags) => {
            if (!tagEditable) return;
            onChange({ ...action, tag: tags.map((tag) => tag.name) });
          }}
          showAddButtonToEnterInput
        />
      </Flex>
    </Flex>
  );
});
